<template>
    <div id="content">
        <link rel="stylesheet" href="/themes/ito/css/parents.css">

        <div class="container">
            <div id="page-header-fixed" class="mb-25">
                <div class="container">
                    <div id="page-header">
                        <div class="buttons">
                            <router-link class="btn btn-default shadow-none" :class="{ active: $route.name == 'parent_report' }" :to="{ name: 'parent_report' }" @click.native="getSoundClick">
                                {{ $t('report') }}
                            </router-link>

                            <router-link class="btn btn-default shadow-none" :class="{ active: $route.name == 'parent_certificate' }" :to="{ name: 'parent_certificate' }" @click.native="getSoundClick" v-if="user_info.student_type == 1">
                                {{ $t('certificate') }}
                            </router-link>

                            <!-- <router-link class="btn btn-default shadow-none" :to="{ name: 'parent_feedback' }"@click.native="getSoundClick" v-if="user_info.student_type == 1">
                  {{ $t('feedback') }}
                </router-link> -->

                            <router-link class="btn btn-default shadow-none" :class="{ active: $route.name == 'parent_account' }" :to="{ name: 'parent_account' }" @click.native="getSoundClick">
                                {{ $t('account_information') }}
                            </router-link>

                            <router-link class="btn btn-default shadow-none" :class="{ active: $route.name == 'upgrade_account' }" :to="{ name: 'upgrade_account' }" @click.native="getSoundClick">
                                {{ $t('upgrade_account') }}
                            </router-link>
                            <router-link class="btn btn-default shadow-none" :class="{ active: $route.name == 'parent_iclass_report' }" :to="{ name: 'parent_iclass_report' }" @click.native="getSoundClick">
                                {{ $t('iCLASS') }}
                            </router-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div id="upgrade-detail" class="card card-comments">
            <div class="card-body">
                <h5 class="card-title">
                    <span class="title">Unclock full access</span>
                </h5>

                <div class="card-content">
                    <div>
                        <div class="select-upgrade-type d-flex mb-20">
                            <template v-for="(pkg, index) in packages">
                                <input :id="'pkg' + index" name="package_select" type="radio" v-model="package_select" :value="pkg.id" />
                                <label :for="'pkg' + index" class="package package-1 box-shadow-main">
                                    <div class="package-title">{{ pkg.name }}</div>
                                    <div class="package-price">199,000 vnđ / tháng</div>
                                    <div class="package-content package-content-1">
                                        <div class="package-items d-flex">
                                            <img src="/themes/ito/images/payment-check-icon.svg">
                                            <div class="package-items-text">iSmart Maths & Science: Vocabulary,
                                                Presentation, Practices.
                                            </div>
                                        </div>
                                        <div class="package-items d-flex">
                                            <img src="/themes/ito/images/payment-check-icon.svg">
                                            <div class="package-items-text">iSmart Maths & Science: Fact Reading,
                                                Home
                                                Science, 4-skill Extended.
                                            </div>
                                        </div>
                                        <div class="package-items d-flex">
                                            <img src="/themes/ito/images/payment-check-icon.svg">
                                            <div class="package-items-text">General English: much more content than
                                                STANDARD.
                                            </div>
                                        </div>
                                        <div class="package-items d-flex">
                                            <img src="/themes/ito/images/payment-check-icon.svg">
                                            <div class="package-items-text">IGS-Bridge</div>
                                        </div>
                                    </div>
                                </label>
                            </template>
                        </div>
                    </div>
                    <div>
                        <p class="label-upgrade">Please select how you would like to pay:</p>
                        <template v-for="(pkg, index) in packages">
                            <div v-for="(item, index) in pkg.products" class="slect-product">
                                <input :id="'product_' + item.product_id" name="product_item" type="radio" v-model="product" :value="item.product_id" />
                                <label :for="'product_' + item.product_id" class="slect-group slect-package justify-content-between box-shadow-main" :class="item.package_id == package_select ? 'slect-show' : 'slect-hide'">
                                    <div class="slect-name">{{ item.product_name }}</div>
                                    <div class="slect-cost">{{ item.price }} &#8363;</div>

                                </label>
                            </div>
                        </template>
                    </div>
                    <div>
                        <p class="label-upgrade">Add a promotion code:</p>
                        <div class="d-flex align-items-center" style="margin-bottom: 12px">
                            <input class="input-promotion" placeholder="Enter the promotion code">
                            <div class="ito-btn-small btn-promotion-code">Apply code</div>
                        </div>
                        <p class="label-upgrade">Choose your payment method:</p>
                        <div class="d-flex slect-method">
                            <template v-for="(gate, index) in gates">
                                <input :id="'method_' + index" name="radio-select" type="radio" v-model="method" :value="gate.method" />
                                <label :for="'method_' + index" class="payment-method-item box-shadow-main">
                                    <div class="img-gate-box">
                                        <img :src="gate.icon">
                                    </div>
                                    <div class="payment-method-text" v-html="gate.name"></div>
                                </label>
                            </template>
                        </div>
                        <div class="btn-payment box-shadow-main" @click="product_id != '' && product != '' ? Payment() : ''">Pay now
                        </div>
                        <!--<div class="btn-payment box-shadow-main" data-bs-dismiss="modal" data-bs-toggle="modal"-->
                        <!--data-bs-target="#PopupPayment">Pay now-->
                        <!--</div>-->
                    </div>
                </div>
            </div>
        </div>

        <div class="modal fade payment-popup" id="PopupPayment" tabindex="-1" role="dialog" aria-labelledby="PopupPayment" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered popup-main-1" role="document" style="max-width: 700px;">
                <div class="modal-content box-shadow-main">
                    <div class="close-popup" data-bs-dismiss="modal"></div>
                    <h3 class="popup-title mb-20">Payment confirmation</h3>
                    <p><b>Your current account information:</b><br />
                        Student ID (username): <b>demo_001</b><br />
                        Current package: <b>iTO PLUS 12 months</b><br />
                        Expire date: <b>19 May, 2022</b><br /><br />
                        Bạn đang thực hiện mua gói cước <b>iTO PRO 1 months.</b><br />
                        Nếu đồng ý thanh toán, gói cước mới sẽ thay thế cho gói <b>iTO PLUS 12 months</b> vẫn đang
                        còn hiệu lực.<br /><br />
                        Bạn có chắc chắn muốn thực hiện thanh toán?</p>
                    <div class="form-group d-flex justify-content-center">
                        <div class="ito-btn-small" style="margin: 0px 10px">Cancel</div>
                        <div class="ito-btn-small active" style="margin: 0px 10px" data-bs-dismiss="modal" data-bs-toggle="modal" data-bs-target="#PopupPaymentFail">Yes
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal fade payment-popup" id="PopupPaymentFail" tabindex="-1" role="dialog" aria-labelledby="PopupPaymentFail" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered popup-main-1" role="document" style="max-width: 475px;">
                <div class="modal-content box-shadow-main paymment-status">
                    <div class="close-popup" data-bs-dismiss="modal"></div>
                    <h3 class="popup-title mb-20 fail">Payment unsuccessfully</h3>
                    <img src="/themes/ito/images/payment-fail.png" width="87px">
                    <div v-html="$t('payment_unsuccess_noti')"></div>
                    <div class="form-group d-flex justify-content-center">
                        <div class="ito-btn-small" style="margin: 0px 10px" data-bs-dismiss="modal" data-bs-toggle="modal" data-bs-target="#PopupPaymentTransfer">Cancel
                        </div>
                        <div class="ito-btn-small active" style="margin: 0px 10px" data-bs-dismiss="modal" data-bs-toggle="modal" data-bs-target="#PopupPaymentSuccess">Yes
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal fade payment-popup" id="PopupPaymentSuccess" tabindex="-1" role="dialog" aria-labelledby="PopupPaymentSuccess" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered popup-main-1" role="document" style="max-width: 475px;">
                <div class="modal-content box-shadow-main paymment-status">
                    <div class="close-popup" data-bs-dismiss="modal"></div>
                    <h3 class="popup-title mb-20 success">Payment successful</h3>
                    <img src="/themes/ito/images/payment-fail.png" width="87px">
                    <div v-html="$t('payment_success_noti')"></div>
                </div>
            </div>
        </div>
        <div class="modal fade payment-popup" id="PopupPaymentTransfer" tabindex="-1" role="dialog" aria-labelledby="PopupPaymentTransfer" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered popup-main-1" role="document" style="max-width: 700px;">
                <div class="modal-content box-shadow-main">
                    <div class="close-popup" data-bs-dismiss="modal"></div>
                    <h3 class="popup-title mb-20">How to use bank transfer method?</h3>
                    <p>Please process payment as per below instruction to complete the upgrade.<br />
                        <b>Account information after complete money transfer:</b><br />
                        Student code (username): <b>demo_001</b><br />
                        Renew package: <b>iTO PRO 12 months</b><br />
                        Expected expired time: <b>19 May, 2022</b><br />
                        <b>Instruction to make money transfer:</b><br />
                        To upgrade, please make money transfer to iTO bank account according to the following
                        information:<br />
                        (1) Beneficiary name: <b>CÔNG TY CỔ PHẦN GIÁO DỤC ISMART</b><br />
                        (2) Bank: <b>Vietcombank</b><br />
                        (3) Account number: <b>87285789759872</b><br />
                        (4) Branch: <b>Sai Thanh</b><br />
                        (5) Total money: <b>150,000đ</b><br />
                        (6) Content: <b>iTO [Student ID] [Phone number]</b><br />
                        For example:<br />
                        Customer has <b>Student ID</b> demo_001, <b>Phone number</b> 09xxxxxx00 demanding to
                        register iTO1 package. Customer needs to enter the content of money transfer as follows:
                        <b>iTO1 demo_001 09xxxxxxx00</b><br /><br />

                        <b>Note:</b><br />
                        In the content of transfer, the information “Student ID” and “Phone number” are required for
                        the account upgrade process completed as soon as possible.<br />
                        This request is auto cancelled by iTO after 72 hours (02 working days, except Saturday and
                        Sunday) if you don't make money transfer to iTO bank account.
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import axios from "axios";
import { pushQueries, soundClick } from '../../utils/utils'
import { mapGetters } from 'vuex'
import { getInboxs, readInbox } from "../../models/inbox";
import { getPackages, postPayment } from "../../models/payment";
import { claimDailyBonus } from "../../models/reward";

export default {
    name: "ParentUpgradeAccount",
    title: 'Parents - Upgrade Account',

    data() {
        return {
            packages: [],
            gates: [],
            isLoading: true,
            product: '',
            package_select: '',
            method: '',
            screen: 1
        };
    },

    created() {
        this.$store.commit('setMenuActive', 'parent');

        this.fetch();
    },

    // watch: {
    //     'package_select': function(newVal, oldVal) {
    //         if(newVal != ''){
    //             this.screen = 2
    //         }
    //     },
    // },

    methods: {
        fetch(page = 1) {
            const that = this;
            //pushQueries(this.$router, '/inbox', params);

            axios.all([
                getPackages(),
            ]).then(axios.spread((package_response) => {
                that.isLoading = false;
                console.log(package_response);
                //that.$store.commit("setLoading", false);

                if (package_response.data.code != 0) {
                    return;
                }
                that.packages = package_response.data.results.packages || [];
                that.gates = package_response.data.results.gate || [];

            }));
        },

        Payment() {
            const that = this;

            that.$store.commit("setLoading", true);
            const formData = new FormData();
            formData.append('product_id', this.product);
            formData.append('voucher', 'xxx');
            formData.append('method', this.method);
            postPayment(formData).then((data) => {
                that.$store.commit("setLoading", false);
                if (data.data.code == 0) {
                    window.location.href = data.data.results.url;
                }
                else {
                    alert(data.data.results);
                }
            }).catch(({ response }) => {
                that.$store.commit("setLoading", false);
                console.log('ect', response);
                alert(response.data.results);
            });
        },

        getSoundClick() {
            soundClick();
        },

    }
}
</script>

<style scoped>
[type="radio"]:not(:checked),
[type="radio"]:checked {
    position: absolute;
    opacity: 0;
    pointer-events: none;
}

.slect-method [type="radio"]+label:before,
.slect-method [type="radio"]+label:after {
    display: none;
}

.slect-method [type=radio]:checked+label.payment-method-item {
    opacity: 1;
    border: 2px solid #40C0F6;
}

.package-content-1 img {
    filter: grayscale(1);
}

.select-upgrade-type [type=radio]:checked+label.package .package-content-1 img {
    filter: grayscale(0);
}

.slect-method label {
    display: block;
    /*width: 100%;*/
    /*height: 100%;*/
}

.slect-show {
    display: flex;
}

.slect-hide {
    display: none;
}

.slect-product [type=radio]:checked+label.slect-package {
    color: #ffffff;
    background: #e98437;
}

.payment-method-item {
    padding: 0;
}

.img-gate-box {
    height: calc(100% - 30px);
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 20px 25px 10px 25px;
}

.img-gate-box img {
    width: 100%;
}

.payment-method-text {
    font-size: 14px;
    line-height: 19px;
    color: #000000;
    margin-top: 0;
    height: 20px;
    display: flex;
    justify-content: center;
    align-items: start;
}
</style>